import React from 'react'
import classes from './Details.module.sass'
import {
  MotivationInterface,
  MotivationRuleInterface,
} from '../../../../../common/types/interfaces'

type Props = {
  el?: MotivationInterface
}

export const Details = ({ el }: Props) => {
  if (!el) return null

  return (
    <div className={classes.container}>
      <div className={classes.title}>Детали мотивации</div>
      <div className={classes.name}>{el.name}</div>
      {el.description && <div className={classes.description}>{el.description}</div>}

      <div className={classes.section}>
        <div className={classes.sectionTitle}>Основные настройки</div>
        {el.costPerOrder && (
          <div className={classes.row}>
            <span className={classes.label}>Фикс за заказ:</span>
            <span className={classes.value}>{el.costPerOrder} ₽</span>
          </div>
        )}
        {el.revenuePercent && (
          <div className={classes.row}>
            <span className={classes.label}>Процент от выручки:</span>
            <span className={classes.value}>{el.revenuePercent}%</span>
          </div>
        )}
      </div>

      {(el.bonusForOrdersCount || el.bonusForRevenue) && (
        <div className={classes.section}>
          <div className={classes.sectionTitle}>Бонусы</div>
          {el.bonusForOrdersCount && el.ordersCountTarget && (
            <div className={classes.row}>
              <span className={classes.label}>Бонус за заказы:</span>
              <span className={classes.value}>
                +{el.bonusForOrdersCount} ₽ за {el.ordersCountTarget} заказов
              </span>
            </div>
          )}
          {el.bonusForRevenue && el.revenueTarget && (
            <div className={classes.row}>
              <span className={classes.label}>Бонус за выручку:</span>
              <span className={classes.value}>
                +{el.bonusForRevenue} ₽ при выручке {el.revenueTarget} ₽
              </span>
            </div>
          )}
        </div>
      )}

      {el.rules && el.rules.length > 0 && (
        <div className={classes.section}>
          <div className={classes.sectionTitle}>Правила ({el.rules.length})</div>
          {el.rules.map((rule: MotivationRuleInterface, idx: number) => (
            <div key={idx} className={classes.ruleItem}>
              {rule.categories && rule.categories.length > 0 && (
                <div className={classes.row}>
                  <span className={classes.label}>Категории:</span>
                  <span className={classes.value}>
                    {rule.categories.map((c) => c.category?.name).filter(Boolean).join(', ')}
                  </span>
                </div>
              )}
              {rule.items && rule.items.length > 0 && (
                <div className={classes.row}>
                  <span className={classes.label}>Товары:</span>
                  <span className={classes.value}>
                    {rule.items.map((i) => i.item?.name).filter(Boolean).join(', ')}
                  </span>
                </div>
              )}
              {rule.costPerOrder && (
                <div className={classes.row}>
                  <span className={classes.label}>Фикс за заказ:</span>
                  <span className={classes.value}>{rule.costPerOrder} ₽</span>
                </div>
              )}
              {rule.revenuePercent && (
                <div className={classes.row}>
                  <span className={classes.label}>Процент от выручки:</span>
                  <span className={classes.value}>{rule.revenuePercent}%</span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}